module.exports = __webpack_public_path__ + "img/tencent_tool.1986fd98.jpg";